module.exports = __webpack_public_path__ + "img/Ventuar_Spiked Halberd.4c0911c1.png";